module.exports = __webpack_public_path__ + "img/bg-login.d8fe1098.svg";